import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { verifyDeviceAuthToken } from "./schema/auth/verify-device-auth-token";
import { enableDeviceAuth } from "./schema/device-auth/enable-device-auth";
import { listDeviceAuth } from "./schema/device-auth/list-device-auth";
import { refreshDeviceToken } from "./schema/device-auth/refresh-device-token";
import { revokeDeviceAuth } from "./schema/device-auth/revoke-device-auth";

// Group related endpoints
const authEndpoints = { verifyDeviceAuthToken };
const deviceAuthEndpoints = {
  enableDeviceAuth,
  listDeviceAuth,
  revokeDeviceAuth,
  refreshDeviceToken,
};

export const rpcDefinition = { ...authEndpoints, ...deviceAuthEndpoints };

export type AuthRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
